<template>
  <GenericModal
    :show="show"
    :width="800"
    :title="modalTitle"
    :show-header="true"
    :show-actions="true"
    :persistent="true"
    content-align="left"
    action-alignment="justify-end"
    :confirm-text="'Return to Dashboard'"
    :cancel-text="blockAdmittedStudent ? 'View ASU Course Catalog' : ''"
    confirm-variant="gold"
    cancel-variant="maroon"
    :confirm-color="'#fec627'"
    :cancel-color="'#8c1d40'"
    @confirm="handleReturnToDashboard"
    @cancel="handleViewCatalog"
    @close="handleReturnToDashboard"
  >
    <!-- Content slot -->
    <template #content>
      <!-- Admitted student content -->
      <div v-if="blockAdmittedStudent" class="text-body-1" style="line-height: 1.6">
        Universal Learner Courses (ULCs) are specifically designed as a pathway for learners who hope to one day attend
        ASU, but they are not available to current degree-seeking ASU students.

        <div class="mt-4">
          As an admitted ASU student, you have access to a wide range of ASU courses and resources designed to help you
          succeed. Please refer to the
          <a
            href="https://catalog.apps.asu.edu/catalog/classes"
            style="color: black; text-decoration: underline"
            target="_blank"
          >
            ASU Course Catalog
          </a>
          for available courses.
        </div>
      </div>

      <!-- Disqualified student content -->
      <div v-else-if="blockDisqualifiedStudent" class="text-body-1" style="line-height: 1.6">
        Your access to Universal Learner Courses has been temporarily suspended due to a violation of the
        <a
          style="color: #8c1d40; text-decoration: underline"
          href="https://docs.google.com/document/d/1pr6nAIQuyp9AzCfeNiXxMoICXI3rksn18scSm5jHMWk/edit"
          target="_blank"
        >
          Learner Code of Conduct
        </a>
        or
        <a style="color: #8c1d40; text-decoration: underline" href="https://webapp4.asu.edu/myasu/" target="_blank">
          academic hold </a
        >.

        <div class="mt-4">
          If you have questions about this policy or your access, please contact our Support Team at
          <a style="color: #8c1d40; text-decoration: underline" target="_blank" href="tel:844-448-7707">
            844-448-7707
          </a>
          or
          <a href="mailto:ulcourses@asu.edu" style="color: #8c1d40; text-decoration: underline" target="_blank">
            ulcourses@asu.edu </a
          >.
        </div>
      </div>
    </template>
  </GenericModal>
</template>

<script>
import GenericModal from './GenericModal.vue';
import UiButton from '../ui/Button.vue';

export default {
  name: 'AccessRestrictionsDialog',

  components: {
    GenericModal,
    UiButton
  },

  emits: ['return-to-dashboard', 'view-catalog'],

  props: {
    show: {
      type: Boolean,
      default: false
    },
    blockAdmittedStudent: {
      type: Boolean,
      default: false
    },
    blockDisqualifiedStudent: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    modalTitle() {
      if (this.blockAdmittedStudent) {
        return 'Universal Learner Courses Unavailable';
      } else if (this.blockDisqualifiedStudent) {
        return 'Course Access Suspended';
      }
      return '';
    }
  },

  methods: {
    handleReturnToDashboard() {
      this.$emit('return-to-dashboard');
    },

    handleViewCatalog() {
      this.$emit('view-catalog');
    }
  }
};
</script>

<style scoped>
.text-body-1 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: -0.2px;
}
</style>
